import React from 'react';

const ProjectCard = ({ title, description, technologies, github }) => (
  <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 transition duration-500 hover:shadow-blue-500/30">
    <h3 className="text-2xl font-semibold mb-3 text-blue-300">{title}</h3>
    <p className="text-gray-300 mb-4 text-base leading-relaxed">{description}</p>
    <p className="text-sm text-blue-200 mb-3">Tech Stack: {technologies}</p>
    {github && (
      <a
        href={github}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block text-sm text-blue-400 font-medium hover:underline"
      >
        View the project
      </a>
    )}
  </div>
);

const Projects = () => {
  const projects = [
    {
      title: "HashProof",
      description:
        "A private blockchain platform using MultiChain and IPFS for tamper-proof crime investigation. Offers secure evidence storage and role-based access.",
      technologies: "MultiChain, IPFS, React, Tailwind CSS, Flask",
      github: "https://github.com/Suprith-44/HashProof",
    },
    {
      title: "AgentX",
      description:
        "SaaS platform for building Retrieval-Augmented Generation (RAG) powered AI agents. Recognized at Kochi Hackathon and Rakathon.",
      technologies: "LangChain, OpenAI, FAISS, React, Flask, Firebase",
      github: "https://github.com/Suprith-44/AgentX",
    },
    {
      title: "Heal-O-Code 2.0",
      description:
        "Organized a HealthTech Hackathon with 50+ teams under the Weal Club. Focused on tech solutions for healthcare challenges.",
      technologies: "React, Tailwind CSS",
      github: "https://heal-o-code-2.vercel.app/",
    },
    {
      title: "SafePay",
      description:
        "A secure UPI app with fraud detection and RDT 3.0 protocol. Alerts users on suspicious transactions using real-time reports.",
      technologies: "React Native, Flask, Firebase, Gemini API",
      github: "https://github.com/Suprith-44/Safepay",
    },
    {
      title: "KnowledgeFlow",
      description:
        "Learning Management System with dual portals for learners and instructors, supporting course management, grading, and certification.",
      technologies: "Java (Javalin), React, Tailwind CSS, Firebase, Maven",
      github: "https://github.com/Suprith-44/KnowledgeFlow",
    },
    {
      title: "PESU Clubs and Events",
      description:
        "Web platform to manage club recruitments and events at PESU with separate views for administrators and students.",
      technologies: "React, Flask, Sqlite3",
      github: "https://github.com/Suprith-44/PESU_ClubsAndEvents",
    },
    {
      title: "YADTQ",
      description:
        "A modular distributed task queue system using Kafka and Redis. Supports scalable message-based task distribution with health checks and status tracking.",
      technologies: "Kafka, Redis",
      github: "https://github.com/Suprith-44/YADTQ",
    },
    {
      title: "Unhigh-Gene",
      description:
        "Streamlines genetic disease prediction using computational analysis of prospective parents’ gene sequences for efficient, automated diagnostics.",
      technologies: "Streamlit, Gene Analysis, Python",
      github: "https://github.com/Suprith-44/Unhigh-Gene",
    },
  ];

  return (
    <section id="projects" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-blue-300 mb-16">
          Projects
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
